<template>
  <div class="relative">
    <input
      type="text"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      class="text-sm rounded border border-solid w-full p-1.5"
      :class="{ 'border-gray-500': !isError, 'border-red-600': isError }"
      :disabled="disabled"
      @focus="onInputFocus"
      @blur="onInputBlur"
      @input="onInput"
      @keyup.enter="onEnter"
      autocorrect="off"
      autocapitalize="none"
      autocomplete="off"
      :autofocus="autofocus"
      list="emailHint" 
    />
    <datalist v-if="showAndroidEmailHint" id="emailHint">
      <option
        v-for="item in emailHintList"
        :value="item"
        :key="item"
      />
    </datalist>
    <ul
      v-show="showEmailHint"
      class="tcsmd-menu md max-h-[300px] overflow-auto"
      tabindex="1"
      @focus="isInputFocus = true"
    >
      <li
        v-for="item in emailHintList"
        :key="item"
        class="tcsmd-menu-item"
        @click="onEmailHintSelect(item)"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
import bowser from 'bowser';
import { mapState } from 'vuex';
import { emailSuffix } from '@/constant';

export default {
  name: "EmailInput",
  props: {
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    id: {
      type: String,
      default: 'email',
    },
    isError: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input", "focus", "enter"],
  data() {
    const browser = bowser.parse(window.navigator.userAgent).browser.name;
    const os = bowser.parse(window.navigator.userAgent).os.name;

    return {
      browser,
      os,
      isInputFocus: false,
      emailHintList: [],
    }
  },
  computed: {
    ...mapState(['userLang']),
    emailSuffixList() {
      if (this.userLang !== 'ja-JP') {
        return [];
      } 

      return emailSuffix;
    },
    showAndroidEmailHint() {
      return (
        this.os === "Android" &&
        this.emailHintList.length > 0 && 
        !(this.emailHintList.length === 1 && this.emailHintList[0] === this.value)
      )
    },
    showEmailHint() {
      return (
        this.os !== "Android" &&
        this.emailHintList.length > 0 && 
        this.isInputFocus &&
        !(this.emailHintList.length === 1 && this.emailHintList[0] === this.value)
      )
    },
  },
  watch: {
    value() {
      this.sortEmailHintList();
    },
    userLang() {
      this.sortEmailHintList();
    },
  },
  methods: {
    sortEmailHintList() {
      this.emailHintList = [];
      if (this.userLang !== 'ja-JP') return;
      if (this.value.length > 1 && this.value.includes('@')) {
        const emailPrefix = this.value.split('@')[0];
        const list = this.emailSuffixList.map(item => `${emailPrefix}@${item}`);
        this.emailHintList = list.filter(item => item.includes(this.value));
      }
    },
    onInputFocus() {
      this.isInputFocus = true;
      this.$emit('focus');
    },
    onInputBlur() {
      setTimeout(() => {
        this.isInputFocus = false;
      }, 200)
    },
    onInput(e) {
      this.$emit('input', e.target.value);
    },
    onEnter() {
      this.$emit("enter");
    },
    onEmailHintSelect(item) {
      this.$emit('input', item);
      this.onInputBlur();
    },
  }
}
</script>

<style lang="sass" scoped>
.tcsmd-menu
  position: absolute
  width: 100%
  z-index: 999

  &-item
    justify-content: flex-start !important
    padding: 4.5px 8px
</style>